import { DateTime } from 'luxon'
import { propSerializer } from 'ymodel'

propSerializer<DateTime, string>(DateTime, {
  deserialize: serialized => DateTime.fromISO(serialized),
  serialize:   dateTime   => dateTime.toISO(),
})